import { Modal, Switch } from "@material-ui/core";
import React, { useState, useEffect } from "react";

const PlanComparisonModal = ({
  showComparisonModal,
  setShowComparisonModal,
  plans_list = [],
}) => {
  const [isAnnual, setIsAnnual] = useState(true);
  console.log("Fetched plan data:", plans_list); // Manage toggle state

  const handleToggle = () => {
    setIsAnnual(!isAnnual);
  };
  return (
    <Modal
      open={showComparisonModal}
      onClose={() => setShowComparisonModal(false)}
    >
      <div className="w-100 h-100 d-flex align-items-center justify-content-center subscriptions-plan-modal">
        <div className="w-100 bg--white subscriptions-plan-modal-content radius--10">
          <div class="subscriptions-plan-modal-header border--bottom-1 p-3 radius--top-left-right-10">
            <button
              type="button"
              class="close"
              onClick={() => setShowComparisonModal(false)}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="font--18 text--black mb-0">
              NxaTel One Full Comparison Plan
            </h4>
          </div>
          <div class="subscriptions-plan-modal-body  p--15">
            <div className="subscriptions-plan-section">
              {/* header start here */}
              <div
                className="subscriptions-plan-header d-flex align-items-center gap--15"
                style={{
                  position: "sticky",
                  top: " 0",
                  zIndex: "1000",
                  backgroundColor: "#fff",
                  borderBottom: "1px solid #e0e0e0",
                  padding: "15px",
                }}
              >
                <div className="subscription-left-content w--260 w--min-220 d-flex align-items-center gap--10">
                  <div
                    className={`toggle-wrapper ${
                      isAnnual ? "annual" : "monthly"
                    }`}
                    onClick={() => setIsAnnual(!isAnnual)}
                  >
                    <span
                      className={`toggle-option ${!isAnnual ? "active" : ""}`}
                    >
                      Monthly
                    </span>
                    <span
                      className={`toggle-option ${isAnnual ? "active" : ""}`}
                    >
                      Annual
                    </span>
                  </div>
                </div>
                <div className="subscription-right-content w-100 d-flex align-items-center gap--15">
                  <div className="w-100 w--min-220 text-left "></div>
                  <div className="w-100 w--min-220 text-center">
                    <h3 className="font--16 text--black fw--600">Start-Up</h3>
                  </div>
                  <div className="w-100 w--min-220 text-center">
                    <h3 className="font--16 text--black fw--600">Scale-Up</h3>
                  </div>
                  <div className="w-100 w--min-220 text-center">
                    <h3 className="font--16 text--black fw--600">
                      Professional
                    </h3>
                  </div>
                  <div className="w-100 w--min-220 text-center">
                    <h3 className="font--16 text--black fw--600">Enterprise</h3>
                  </div>
                </div>
              </div>
              {/* container start here */}
              <div className="subscriptions-plan-container w-100  ">
                {/*Cloud Calling */}

                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Cloud Calling
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* Monthly Price */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          {isAnnual
                            ? "Annual Price Per User"
                            : "Monthly Price Per User"}
                        </p>
                      </div>

                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => {
                          const planCost = isAnnual
                            ? plan.yearly_cost?.amount
                            : plan.monthly_cost?.amount;
                          const currencySymbol =
                            plan.currency === "USD"
                              ? "$"
                              : plan.currency === "ZAR"
                              ? "R"
                              : "N/A"; // Add more currencies as needed

                          return (
                            <div
                              key={plan.planID}
                              className="w-100 w--min-220 text-center"
                            >
                              {plan.planID >= 1 && plan.planID <= 4
                                ? `${currencySymbol}${
                                    planCost ?? "Custom Pricing"
                                  }`
                                : "Custom Pricing"}
                            </div>
                          );
                        })
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>

                    {/*Annual Price per user -Up-to- 16% */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Annual Discount Per User - Up To 18%
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 1 && plan.planID <= 4
                              ? `${plan.annual_plan_discount}%`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>

                    {/* 24 Month Price*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          24 Month Discount Per User - Up To 20%
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 1 && plan.planID <= 4
                              ? `${plan.two_year_plan_discount}%`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>

                    {/* License Size */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          License Minimum
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 1 && plan.planID <= 4 ? (
                              <p className="text--black">{plan.min_user}</p>
                            ) : (
                              <p>N/A</p>
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>

                    {/*Call Minutes */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Call Minutes
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 1 && plan.planID <= 4
                              ? `${plan.voice_minute}`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/* SMS */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">SMS</p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 1 && plan.planID <= 4
                              ? `${plan.sms}`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>

                    {/* Storage */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">Storage</p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 1 && plan.planID <= 4
                              ? `${plan.storage}`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>

                    {/* Additional Line */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Additional Line
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R114.00
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R114.00
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R114.00
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        R114.00
                      </div>
                    </div>

                    {/* Additional Line USD */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Additional Line USD
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">$6.00</div>
                      <div className="w-100 w--min-220 text-center">$6.00</div>
                      <div className="w-100 w--min-220 text-center">$6.00</div>
                      <div className="w-100 w--min-220 text-center">$6.00</div>
                    </div>
                    {/* Local Geo/National Numbers */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Local Geographical/National Numbers Available
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 1 && plan.planID <= 4
                              ? `${plan.free_did_number}`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>

                    {/* Port Numbers*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Port your current numbers
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* International Long Distance */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          International Long Distance
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">Add-On</div>
                      <div className="w-100 w--min-220 text-center">Add-On</div>
                      <div className="w-100 w--min-220 text-center">Add-On</div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* Technical Support */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Technical Support Onboarding
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Team Communication box start here */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black ">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Team Communication
                    </h3>
                    <p className="font--12 text--gray-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/*Team Communication */}
                    {/* 1 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Connect Mobile App (iOS/Android)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />

                        {/* <img src="/assets/images/crossRed.svg" className="w--mx-25" /> */}
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Connect Desktop App(Web)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />

                        <div className="w-100 w--min-220 text-center"></div>
                        {/* <img src="/assets/images/crossRed.svg" className="w--mx-25" /> */}
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Team Voice & Video Calling
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Team Messaging
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>

                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 5 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Presence & Chat
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>

                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Video Calling (1-to-1)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>

                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Team Audio Conferencing
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>

                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 8 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Team Collaboration Channels
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>

                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 9 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Screen Sharing (1-to-1)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>

                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 10 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          File Sharing (Team & 1-to-1)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>

                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 11 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Business SMS Templates
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>

                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 12 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          VoIP Faxing (Outbound)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>

                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 13 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Scan to PDF</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>

                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Meetings and Conferences start here */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Meetings and Conferences
                    </h3>
                    <p className="font--12 text--gray-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Personal Conference Bridge (Audio Only)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Web-based Conference Management
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Audio and Video Web Meetings
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Video Participants
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 1 && plan.planID <= 4
                              ? `${plan.participants_for_video_confrence}`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/* 5*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Video Calling Minutes
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 1 && plan.planID <= 4
                              ? `${plan.video_calling_minutes}`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/*6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Sync Calender
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Screen Sharing - Web Only
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 8 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Cloud Storage: Audio, Video Recordings, Documents
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 2 && plan.planID <= 4
                              ? `${plan.cloud_storage}`
                              : "Add-On"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/*9  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Groups - Video
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 10 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">Notes</p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 1 && plan.planID <= 4
                              ? `${plan.notes}`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/*11  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Live Polls</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*12  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Live Stream - Social Platforms
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*13  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Company Branding
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 14 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Customised Domain - Meeting Link
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Desk Phones start here */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Desk Phones
                    </h3>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          IP Desk Phone Support
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Bring Your Own Desk Phone
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Customized BLF Layout
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Analog Device Support (Requires ATA)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Voicemail start here */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Voicemail
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Personal Mailbox
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Voicemail to E-mail Delivery
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Voicemail Transcription
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Team Voicemail
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Call Routing */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Call Routing
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Advanced Call Routing (Call Flow)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Personalized Call Routing (Call Forwarding)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Hunt Groups</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Call Groups</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 5 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Customized Call Schedules
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Weekend and Holiday Call Routing
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Day/Night Mode
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 8 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Elevate Call to NxaMeet Meeting
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 9 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Barge/Monitor/Whisper/Takeover
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bussiness Features */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Business Features
                    </h3>
                    <p className="font--12 text--gray-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Assign Contacts
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Share Contacts
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Back Scheduler in Planner
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Pop Feature - Advanced Call Line ID With Customer
                          Info & Survey After Each Call
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 5*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Basic Music on Hold
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* Customizable  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Customizeable Music On Hold
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Personal Music On Hold
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Multi-Level Automated Attendent
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 8 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Activity Reports
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*9  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Business Contacts
                        </p>
                      </div>

                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 1 && plan.planID <= 4
                              ? `${plan.business_contacts}`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/* 10 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          User Web Portal
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*11  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          User Permissions/Roles
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*12  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Email Notifications
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*13  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 ">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Administrator Wen Portal
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Call Features */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Call Features
                    </h3>
                    <p className="font--12 text--gray-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Find me/Follow Me
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Call Flip</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Reporting
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Group Pickup
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 5*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Park and Pickup
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Forwarding
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Transfer (Warm)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Transfer (Cold)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 8 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Caller ID</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*9  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Waiting
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 10 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Do Not Disturb
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*11  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Page Groups</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*12  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Recording (On-Demand)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*13  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Recording (Continuous)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*14  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call History
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*15  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 ">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Transfer Audio call to NxaMeet Meeting
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Discover */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Discover
                    </h3>
                    <p className="font--12 text--gray-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Business Listing on Discover
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Find Your Business On Discover
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Postings on Discover
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Promote Products on Discover - Enquiry Form
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 5*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Connect Planner
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Notifications when users visit your page
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Business Analytics
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 8 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Bulk In App Messages to Followers
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*9  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Bulk Customer SMS's - To Followers
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 10 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call, Video in Discover
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*11  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Followers in Discover
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/*NXAStore start here */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      NxaStore
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Access NxaStore Products
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Buy and Checkout
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Mobile Wallet
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Transfer Funds/Minutes Between Users
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/*  Power Apps*/}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Power Apps
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Notes</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Cloud Storage [Audio, Video, Images, Documents]
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 1 && plan.planID <= 3 ? (
                              `${plan.storage}`
                            ) : (
                              <img
                                src="/assets/images/tickcircle.svg"
                                className="w--mx-25"
                              />
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Cloud Recording
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Cloud Mail</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 5 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Sync Calendar
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* NXA MARKETPLACE INTEGRATION */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      NXA Marketplace Intergration
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/*1 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Zoho Intergration
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Sage One Intergration
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Xero Intergration
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Google</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 5 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Microsoft</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">MS Outlook</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Google Contacts
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 8 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Hubspot</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 9 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Zendesk</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 10 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Zapier</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 11 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Yealink</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 12 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Logitec</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Support */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Support
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Support Hours
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        8am-5pm CAT
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        8am-5pm CAT
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        8am-5pm CAT
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        8am-5pm CAT
                      </div>
                    </div>

                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Email Support
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Live Support
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Phone Support
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Priority Support
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 5 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Professional Implementation
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">Add On</div>
                      <div className="w-100 w--min-220 text-center">Add On</div>
                      <div className="w-100 w--min-220 text-center">Add On</div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Multi-site support
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Service Level Agreement (SLA)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">Add On</div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 8 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Dedicated Account Manager
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 9 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Professional Deployment Services
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">Add On</div>
                      <div className="w-100 w--min-220 text-center">Add On</div>
                      <div className="w-100 w--min-220 text-center">Add On</div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* REPORTING & ADMINISTRATION */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Reporting and Administration
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Customer database Export/Import
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Reports</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          User and team performance
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Dashboard</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 5 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call History
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Log Reports
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Planner</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 8 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Call Reporting Dashboard
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 9 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Admin Portal
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* footer start here */}
              <div className="subscriptions-plan-modal-footer w-100 d-flex align-items-start gap--15 mt--15 pt--12 pb--12 bg--white">
                <div className="subscription-left-content w--260 w--min-220 d-flex align-items-start gap--10">
                  <h3 className="font--14 text--black plan-title position-relative mb--5">
                    Price
                  </h3>
                </div>
                <div className="subscription-right-content w-100 d-flex align-items-start gap--15">
                  <div className="w-100 w--min-220 text-left">
                    <p className="font--12 text--black lh--19 mb-0">
                      Billed monthly, from
                    </p>
                  </div>
                  {plans_list.length > 0 ? (
                    plans_list.map((plan) => {
                      const planCost = isAnnual
                        ? plan.yearly_cost?.amount
                        : plan.monthly_cost?.amount;
                      const currencySymbol =
                        plan.currency === "USD"
                          ? "$"
                          : plan.currency === "ZAR"
                          ? "R"
                          : "N/A"; // Add more currencies as needed

                      return (
                        <div
                          key={plan.planID}
                          className="w-100 w--min-220 text-center"
                        >
                          {plan.planID >= 1 && plan.planID <= 2 ? (
                            <>
                              <div className="w-100 h--min-65 text-center">
                                <h3 className="font--16 text--black fw--600 mb--5">
                                  {`${currencySymbol}${
                                    planCost ?? "Custom Pricing"
                                  }`}
                                </h3>
                              </div>
                              <a href="https://nxa.tel/signup">
                                {" "}
                                <span className="btn bg--orange-ea7414 border--orange-ea7414 pt--5 pb--5 pr--20 pl--20 radius--8 font--15 text--white dm--sans fw--700">
                                  Try for Free
                                </span>
                              </a>
                            </>
                          ) : (
                            <>
                              <div className="w-100 h--min-65 text-center">
                                <h3 className="font--16 text--black fw--600 mb--5">
                                  {`${currencySymbol}${
                                    planCost ?? "Custom Pricing"
                                  }`}
                                </h3>
                              </div>
                              <a href="https://nxa.tel/demo">
                                {" "}
                                <span className="btn bg--orange-ea7414 border--orange-ea7414 pt--5 pb--5 pr--20 pl--20 radius--8 font--15 text--white dm--sans fw--700">
                                  Get Demo
                                </span>
                              </a>
                            </>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <div className="w-100 w--min-220 text-center">
                      Loading...
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PlanComparisonModal;
